import * as React from 'react'
import { DropdownMenu } from 'components/ds'

type Props = {
  links?: React.ReactNode[]
  title: string | React.ReactNode
  label?: string
}

const DropdownSubmenu = ({
  title,
  links,
  label,
}: Props): React.ReactElement => (
  <DropdownMenu.Sub>
    <DropdownMenu.SubTrigger>{title}</DropdownMenu.SubTrigger>
    <DropdownMenu.SubContent>
      {label && <DropdownMenu.Label>{label}</DropdownMenu.Label>}
      {links}
    </DropdownMenu.SubContent>
  </DropdownMenu.Sub>
)

export default DropdownSubmenu
